import { render, staticRenderFns } from "./event-class.vue?vue&type=template&id=223fd3fc&scoped=true"
import script from "./event-class.vue?vue&type=script&lang=js"
export * from "./event-class.vue?vue&type=script&lang=js"
import style0 from "./event-class.vue?vue&type=style&index=0&id=223fd3fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223fd3fc",
  null
  
)

export default component.exports